import request from 'oc-request';

export default () => ({
    isLoading: false,
    errorMessage: null,

    performSearch(query, documentId = null, searchEngine = 'yandex', onSuccess = () => {}, onError = () => {}) {
        this.isLoading = true;
        this.errorMessage = null;

        return new Promise((resolve, reject) => {
            request.sendData('SerpComponent::onQuerySearch', {
                data: {
                    query,
                    documentId,
                    searchEngine,
                },
                loading: '.preloader-selector',

                success: (response) => {
                    this.isLoading = false;
                    onSuccess(response);
                    resolve(response);
                },

                error: (xhr) => {
                    this.isLoading = false;
                    this.errorMessage = 'Ошибка выполнения запроса';
                    console.error('Search error:', xhr);
                    onError('Ошибка выполнения запроса');
                    reject(xhr);
                },
            });
        });
    },
});
